// extracted by mini-css-extract-plugin
export default {"standard_button":"StandardButton_standard_button__m7TBQ","loading_button":"StandardButton_loading_button__Ku-rs","loader":"StandardButton_loader__YnlhY"};